import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup, Validators} from '@angular/forms';
import {NotEmptyStringValidator} from '../../../../../../../../../../validators/ControlValidators';

@Component({
  selector: 'shared-komentarz',
  templateUrl: './komentarz.component.html',
  styleUrls: ['./komentarz.component.scss']
})

export class KomentarzComponent implements OnInit {

  @Input()
  formularzUszkodzenia!: UntypedFormGroup;

  @Input()
  etykietaWartosci = '';

  ngOnInit(): void {
    this.formularzUszkodzenia.controls.komentarz.setValidators([Validators.required, NotEmptyStringValidator.validate]);
  }
}
